import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from '../services/general.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-add-department',
  templateUrl: './add-department.component.html',
  styleUrls: ['./add-department.component.scss']
})
export class AddDepartmentComponent implements OnInit {
  AddDepartmentForm: FormGroup;
  displayedColumns: string[] = [
    "ID",
    "Name",
    "action",
  ];
  Departments: any;
  update: boolean;
  DepartmentId: any;
  constructor(private _formBuilder: FormBuilder,  public GeneralService: GeneralService) {
    
   }
initForm() {
    this.AddDepartmentForm = this._formBuilder.group({
    Name: [ '', Validators.required],
    });
  }
  ngOnInit() {
    this.initForm();
    this.GetAllDepartments();
  }
GetAllDepartments(){
  this.Departments=[];

  this.GeneralService.getallDepartment().then(res=>{
    console.log(res)
    this.Departments=res;
  })
}

InsertDepartment(){
  const data={
    name:this.AddDepartmentForm.get("Name").value
  }
  this.GeneralService.addDepartment(data).then(res=>{
    this.GetAllDepartments();
    this.AddDepartmentForm.reset();
  })
}

UpdateDepartment(){
  const data={
    name:this.AddDepartmentForm.get("Name").value
  }
  this.GeneralService.UpdateDepartment(data,this.DepartmentId).then(res=>{
    this.GetAllDepartments();
    this.AddDepartmentForm.reset();
    this.update=false;
  })
}
Edit(item){
  this.DepartmentId=item.id;
  this.update=true;
this.AddDepartmentForm.get("Name").setValue(item.name);
}
applyFilter(e){
  
}
DeleteDepartment(item){
  Swal.fire({
    title: " Warning !",
    text: "Are you sure to delete this Department",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: '#7364f6',
    cancelButtonColor: "#d33",
    confirmButtonText: "Delete",
    cancelButtonText: "Back",
  }).then((result) => {
    if (result.isConfirmed) {
      this.GeneralService.DeleteDepartment(item.id).then(
        (res) => {
          
          Swal.fire({
            icon: "success",
            title: "Success Department Deleted",
            showConfirmButton: false,
            timer: 1500,
          });
          this.GetAllDepartments();
        },
        (err) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: err.error,
          });
        }
      );
    } else {
    
    }
  });
}



Submit(){
  console.log(this.AddDepartmentForm.value)
  if (this.AddDepartmentForm.status == "VALID") {
    if (this.update == true) {
      this.UpdateDepartment();
    } 
    else {
      this.InsertDepartment()
    }
  }
   else {
    this.AddDepartmentForm.markAllAsTouched();
  }
}
}
